import apiSlice from "./apiSlice";

const scheduleDprApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getScheduleDPRDetail: builder.query({
            query: (req) => ({
                url: `quantity-dpr/${req}`,
                params: req,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getAllScheduleDPRList: builder.query({
            query: (req) => ({
                url: `quantity-dpr`,
                params: req,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getSubmittedScheduleDPRList: builder.query({
            query: (req) => ({
                url: `quantity-dpr/GetSubmittedDprs`,
                params: req,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        updateScheduleDPRWorkFlow: builder.mutation({
            query: (body) => ({
                url: `quantity-dpr/UpdateWorkflow`,
                method: 'POST',
                body,
            }),
        }),
    }),
});

export const {
    useGetScheduleDPRDetailQuery,
    useUpdateScheduleDPRWorkFlowMutation,
    useGetAllScheduleDPRListQuery,
    useGetSubmittedScheduleDPRListQuery
} = scheduleDprApiSlice;
